import { atom } from 'recoil';

export const UserAtom = atom({
  key: 'user',
  default: null,
});
